import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { apiActivitiesForParentGet$Json } from 'amoxcalli-academic-api';

import { environment } from '../../../../environments/environment';
import { TareasActions } from './tareas.actions';

@Injectable()
export class TareasEffects {
  private readonly actions$ = inject(Actions);
  private readonly http     = inject(HttpClient);

  loadTareas$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TareasActions.loadTareas),
      switchMap(({ studentId }) =>
        apiActivitiesForParentGet$Json(this.http, environment.serverUrl.academic, { studentId }).pipe(
          map((response) => {
            const tareas = (response.body ?? []).map((dto) => ({
              id:             dto.id ?? '',
              subjectName:    dto.subjectName ?? '',
              periodName:     dto.periodName ?? '',
              periodNumber:   dto.periodNumber ?? 0,
              tipoContenedor: dto.tipoContenedor ?? 0,
              evaluationType: dto.evaluationType ?? 0,
              name:           dto.name ?? null,
              description:    dto.description ?? null,
              fechaEntrega:   dto.fechaEntrega ?? null,
              elaborationDate: dto.elaborationDate ?? null,
              createdAt:      dto.createdAt ?? '',
              calificada:     dto.calificada ?? false,
              calificacion:   dto.calificacion ?? null,
            }));
            return TareasActions.loadTareasSuccess({ tareas });
          }),
          catchError(() =>
            of(TareasActions.loadTareasFailure({ error: 'No se pudieron cargar las tareas y trabajos.' }))
          )
        )
      )
    )
  );
}
